import { EMarketName } from '../ui-config/marketsConfig';

export const checkMarketFeesExists = (marketName?: EMarketName) => marketName === EMarketName.Uniswap;
